export enum HighLevelConceptFilters {
    Active = 'active',
    All = 'all',
    Deprecated = 'deprecated',
    Draft = 'draft',
    New = 'new',
    Proposed = 'proposed',
    UnderRevision = 'in review',
}
